module.exports = __webpack_public_path__ + "static/media/team.eb70d0e6.svg";